module.exports = __webpack_public_path__ + "01_long_yellow.a7f8437b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_long_yellow.png
// module id = iC5d
// module chunks = 0